import moment from "moment";
import {Concept} from "../application/api/applicationModels";

interface TicketModalState {
    isOpen: boolean;
    locationPk?: number;
    orderDate?: string;
    ticketNumber?: number;
}

let globalTicketModalState: TicketModalState = {isOpen: false};
let ticketModalCallbacks: Array<(state: TicketModalState) => void> = [];

export const registerTicketModalCallback = (
    callback: (state: TicketModalState) => void
) => {
    ticketModalCallbacks.push(callback);
    return () => {
        ticketModalCallbacks = ticketModalCallbacks.filter((cb) => cb !== callback);
    };
};

export function openTicket(
    orderDate: string,
    locationPk: number,
    ticketNumber: number,
    concept: Concept,
    legacySiteBaseUrl: string
): void {
    const formattedOrderDate = moment(orderDate).format("YYYY-MM-DD");

    // Check if it's Popeyes, use the new modal
    if (
        (concept === Concept.Popeyes) &&
        ticketModalCallbacks.length > 0
    ) {
        globalTicketModalState = {
            isOpen: true,
            locationPk,
            orderDate: formattedOrderDate,
            ticketNumber
        };

        ticketModalCallbacks.forEach((callback) => callback(globalTicketModalState));
    } else {
        const legacyBusinessDate = moment(orderDate).format("MM/DD/YYYY");
        legacySiteBaseUrl +=
            "/CashMgmt/DrillDown_Ticket.aspx?LID=" +
            locationPk +
            "&B=" +
            legacyBusinessDate +
            "&TN=" +
            ticketNumber;
        window.open(
            legacySiteBaseUrl,
            "_blank",
            "location=no,toolbar=no,menubar=yes,status=no,resizable=yes,scrollbars=yes,height=600,width=700,top=30,left=50"
        );
    }
}

export function closeTicketModal(): void {
    globalTicketModalState = {isOpen: false};
    ticketModalCallbacks.forEach((callback) => callback(globalTicketModalState));
}

export function getTicketModalState(): TicketModalState {
    return {...globalTicketModalState};
}
